module.exports = __webpack_public_path__ + "img/up.8ad8e1af.svg";